/**
 * Main Page file for Project Page
 *
 * @author Creator-Solutions -> Owen Burns
 */

const ProjectPage = () => {
  return (
    <div style={{ width: "40vw", margin: "auto" }}>
      <h5 style={{ color: "#fff", textAlign: "center", paddingTop: "25px" }}>
        Projects Coming Soon...
      </h5>
    </div>
  );
};

export default ProjectPage;
